/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const EqualSlug: core.serialization.ObjectSchema<serializers.EqualSlug.Raw, Truvity.EqualSlug> =
    core.serialization.object({
        value: core.serialization.string(),
    });

export declare namespace EqualSlug {
    export interface Raw {
        value: string;
    }
}
